<template>
    <div class="row headerPaneHorizontal" style="width:56rem;min-width:56rem;">
        <div class="col-12">

            <div class="row headerPaneRowCombined headerText">

                <div class="col-6 headerTXOCBox01">
                    MY PROGRESS
                </div>

                <div class="col-6 headerLoginBox01">
                    View My Badges (10)
                </div>
                <div class="col-6 headerLoginBox02">
                    View My Badges (10)
                </div>

            </div>

            <div class="row">
                <div class="col-12 headerSeparator"></div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'Header',
        data() {
            // let langChoice = this.$cookies.get('langChoice');
            let newLang;
            let newLangTitle;
            if (this.$store.state.langChoice === 'en') {
                newLang = 'es';
                newLangTitle = 'Español';
            } else {
                newLang = 'en';
                newLangTitle = 'English';
            }
            // console.log(this.$route.fullPath);
            return {
                envVars: process.env,
                store: this.$store,
                newLang: newLang,
                newLangTitle: newLangTitle
            };
        },
        props: {
            msg: String
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../styles/header";
</style>
